export const isEmptyNullOrUndefined = (obj: unknown): boolean => {
  if (obj === null || obj === undefined) {
    return true;
  } else if (Array.isArray(obj)) {
    return obj.length === 0;
  } else if (typeof obj === 'object') {
    if (Object.keys(obj).length === 0) {
      return true;
    }

    return Object.entries(obj).every(([_, value]: [string, unknown]): boolean =>
      isEmptyNullOrUndefined(value),
    );
  } else if (typeof obj === 'string') {
    return obj === '';
  } else {
    return false;
  }
};
